import { FormPageLayout } from '../layouts';

/**
 * Let's Discuss Your Project page
 * Contact form page for project consultations
 * Using the FormPageLayout layout component for consistent structure
 *
 * @returns {JSX.Element} Let's Discuss Your Project page
 */
function DiscussProject() {
  return (
    <FormPageLayout
      title="Tell Us About Your Project"
      subtitle="Partner with Our Community to turn your modernization goals into reality."
      formHeading="Let's Discuss Your Project"
      formFilePath="/forms/discuss-project-form.txt"
      errorMessage="Unable to load contact form"
      loadingMessage="Loading contact form..."
    />
  );
}

export default DiscussProject;
